import { openBlock as t, createElementBlock as n, createElementVNode as e } from "vue";
import { _ as r } from "./_plugin-vue_export-helper-dad06003.js";
const s = {}, i = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function c(C, o) {
  return t(), n("svg", i, o[0] || (o[0] = [
    e("path", {
      d: "M3.7439 5.99682C3.49691 6.02484 3.26671 6.13573 3.09085 6.3114C2.91499 6.48707 2.80385 6.71715 2.77555 6.9641C2.52599 9.0979 2.52599 11.2535 2.77555 13.3873C2.8337 13.8947 3.23647 14.2986 3.7439 14.3546C5.9195 14.5967 10.0804 14.5967 12.255 14.3546C12.5021 14.3268 12.7326 14.216 12.9086 14.0403C13.0847 13.8646 13.196 13.6344 13.2244 13.3873C13.4739 11.2535 13.4739 9.09789 13.2244 6.9641C13.196 6.71699 13.0847 6.48678 12.9086 6.31109C12.7326 6.13541 12.5021 6.02461 12.255 5.99682M7.99995 9.33739V1.46484M7.99995 1.46484C8.9905 1.95959 9.9821 2.95119 10.4779 3.94173M7.99995 1.46484C7.00835 1.95959 6.01781 2.95119 5.52201 3.94173",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ r(s, [["render", c]]), l = {}, d = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function _(C, o) {
  return t(), n("svg", d, o[0] || (o[0] = [
    e("path", {
      d: "M2.60113 12.3628C2.60501 12.7551 2.6089 13.1499 2.6089 13.5448M2.57912 7.28131C2.55711 8.00631 2.55841 8.79863 2.56617 9.63238M2.88595 4.53408C3.00247 4.10167 3.15524 3.76247 3.36108 3.5372C3.56564 3.31064 3.85305 3.12292 4.2026 2.97015M6.54979 2.43287C7.22571 2.3649 7.90437 2.32775 8.58367 2.32153M11.0422 2.36685C11.3879 2.38109 11.7284 2.39921 12.0598 2.41863M16.2803 15.5839C16.3749 13.757 16.4017 11.9273 16.3606 10.0985C16.3519 9.62369 16.2053 9.16171 15.9385 8.76885C15.1682 7.6451 14.53 6.90457 13.5525 6.06564C13.1322 5.71024 12.6011 5.51246 12.0507 5.50635C11.728 5.50038 11.4052 5.49736 11.0823 5.49729C9.99613 5.49729 9.0847 5.52707 8.18233 5.58274C7.58017 5.62142 7.01329 5.88031 6.58973 6.31008C6.16617 6.73984 5.91555 7.31043 5.88564 7.9131C5.75292 10.4683 5.75292 13.0287 5.88564 15.5839C5.95037 16.8319 6.9343 17.8365 8.18104 17.9142C9.14696 17.9742 10.1146 18.0031 11.0823 18.001C12.1698 18.001 13.0813 17.9712 13.9849 17.9155C14.5869 17.8765 15.1534 17.6175 15.5767 17.1878C16 16.758 16.2504 16.1876 16.2803 15.5851V15.5839Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const h = /* @__PURE__ */ r(l, [["render", _]]);
export {
  h as C,
  u as U
};
